var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgLogo2 = function SvgLogo2(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 11,
    viewBox: "0 0 22 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_574_988)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1961 2.35676C17.3615 0.743427 15.749 -0.253906 13.995 -0.253906H0.698748C0.444139 -0.253906 0.246109 -0.0339063 0.246109 0.230094C0.246109 0.347427 0.288544 0.479427 0.373414 0.567427L3.27313 3.58876C3.52774 3.85276 3.88136 3.99943 4.23499 3.99943H13.6131C14.2779 3.99943 14.8296 4.54209 14.8296 5.24609C14.8296 5.93543 14.3062 6.50743 13.6272 6.50743H7.17714C6.92253 6.50743 6.7245 6.72743 6.7245 6.99143C6.7245 7.12343 6.76694 7.24076 6.85181 7.32876L9.75152 10.3501C10.0061 10.5994 10.3598 10.7461 10.7134 10.7461H13.6414C17.4464 10.7461 20.3178 6.53676 18.1961 2.35676Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_574_988"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.3125,
    height: 11,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgLogo2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo2.529c641c9b73db7b98ff368b594fe342.svg";